import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import "./style.css";
import InitialChat from "./InitialChat";
import {
  chatArisApi,
  chatArisApiRelationShip,
  createMsg,
  getChatHistory,
  getLatestChatHistory,
  initiateChatSession,
  onChatEnd,
  parseStreamingResponse,
} from "../../Services/Chat";
import {
  convertMessages,
  convertToNewFormat,
} from "../../Utils/CommonFunctions/chats";
import { useHeader } from "../../Providers/HeaderContextProvider";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import SessionSelection from "./LiveSession/SessionSelection";
import { Tooltip } from "react-tooltip";
import { ReactComponent as CheckGreen } from "../../Assets/icon/check-green.svg";
import {
  fetchInsightContent,
  getRelationshipAdvice,
  getRelationshipProfile,
} from "../../Services/Realtionship";
import { chatCreateRelationShip } from "../../Services/arisAI";
import { fetchElementsIntroConfig } from "../../Services/contentConfig";
import AddRelationShipChatModal from "./AddRelationShipChatModal";
import { getSessions, fetchPrivateInstructions } from "../../Services/coaching";
import DefaultLoader from "../LoadingPage/DefaultLoader";
import InviteDecisionModal from "../../Components/InviteDecisionModal";
import RequestCoachingMinutes from "./Dialogues/RequestCoachingMinutes";
import ChatModal from "../../Components/ChatModal/ChatModal";
import MobilePopUp from "../../Components/MobilePopUp/MobilePopUp";
import { isMobile } from "react-device-detect";
import { CoachingTopicsModal, TopicOptionsModal } from "../../Components/CoachingTopics";
import { YourElementsModal } from "../../Components/YourElements";
import ArisTour from "../../Components/Tours/ArisTour";
import { useFunctionalityAccess } from "../../Providers/FunctionalityAccessProvider";

function DashboardChat() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const adviceTitle = searchParams.get("adviceTitle");
  const relationId = searchParams.get("relationId");
  const requestIdFromUrl = searchParams.get("request");

  const { setHeaderContent, screenWidth } = useHeader();
  const { hasUnlimitedCoaching, getCoachingMinutes, initialized: accessInitialized, refreshAccess } = useFunctionalityAccess();
  const isKeyboardHome = typeof window !== 'undefined' && window.location.pathname === '/dashboard';
  const navigate = useNavigate();
  const [chatData, setchatData] = useState([]);
  const chatDataHistoryRef = useRef([]);
  const adviceList = useRef([]);
  const isRelationShipAdvice = useRef(false);
  const isAddRelationProcess = useRef(false);
  const chatInstructionRelation = useRef({});
  const chatSessionId = useRef("");
  const relationshipFollowupRef = useRef(false);
  const collectedRelationShipFormData = useRef({});
  const [latestInProgressSession, setLatestInProgressSession] = useState(false);
  const [enableCoaching, setEnableCoaching] = useState(true);
  const [lastMsg, setLastMsg] = useState("");
  const [loading, setLoading] = useState(true);
  const [hideChatInput, sethideChatInput] = useState(false);
  const [isChatProgress, setIsChatProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isPrivacyActivated, setIsPrivacyActivated] = useState(false);
  const [contactSelectionRelationAdvice, setcontactSelectionRelationAdvice] =
    useState(null);
  const [isElementsMode, setIsElementsMode] = useState(false);
  const [hasSelectedDomain, setHasSelectedDomain] = useState(false);
  const elementsContextRef = useRef({ scope: null, domain: null, level: null });
  const elementsTopicRef = useRef(null);
  const moduleRefId = useRef("");
  const isPrivacyActivatedRef = useRef(false);

  // Invitation modal state (dashboard-specific)
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [inviteNotification, setInviteNotification] = useState(null);
  const [elementsIntroConfig, setElementsIntroConfig] = useState(null);
  const lastLoadedRelationIdRef = useRef(null);

  // Dashboard-specific modals
  const [showEditRelationship, setshowEditRelationship] = useState(false);
  const [showLiveSessionModal, setshowLiveSessionModal] = useState(false);
  const [collectedFormDataRelationship, setcollectedFormDataRelationship] =
    useState({});

  // Coaching minutes state
  const [coachingMinutes, setCoachingMinutes] = useState(null);
  const [showMinutesModal, setShowMinutesModal] = useState(false);

  // Coaching Topics state
  const [showCoachingTopicsModal, setShowCoachingTopicsModal] = useState(false);
  const [showTopicOptionsModal, setShowTopicOptionsModal] = useState(false);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [topicsSlideFromLeft, setTopicsSlideFromLeft] = useState(false);
  const [showYourElementsModal, setShowYourElementsModal] = useState(false);

  // Normalize relationship payloads coming from different sources to a single shape
  const normalizeAdviceData = useCallback((data) => {
    if (!data || typeof data !== "object") return data;
    const defaults = {
      nickname: null,
      pressure: false,
      relationship_category: undefined,
      relationship_goals: null,
      relationship_length: undefined,
      relationship_status: undefined,
      relationship_type: undefined,
      user1_id: undefined,
      user2_id: undefined,
    };
    return { ...defaults, ...data };
  }, []);

  // Handle direct advice from URL params
  useEffect(() => {
    if (!adviceTitle || !relationId) return;
    if (lastLoadedRelationIdRef.current === relationId) return;
    lastLoadedRelationIdRef.current = relationId;

    async function fetchData() {
      try {
        const e = await getRelationshipProfile(relationId);
        adviceList.current = e;
        await pushInData({
          type: "initiateRelationship",
          subType: "directAdviceAddNew",
          text: "I need relationship advice for ",
          name: e?.nickname || e?.first_name || "this person",
          ...normalizeAdviceData(e),
        });
      } catch (error) {
        console.error("Error fetching relationship profile:", error);
      }
    }
    fetchData();
  }, [adviceTitle, relationId, normalizeAdviceData]);

  // Handle deep-linked advice
  useEffect(() => {
    if (!adviceTitle || !relationId) return;
    if (lastLoadedRelationIdRef.current === relationId) return;
    lastLoadedRelationIdRef.current = relationId;

    async function fetchData() {
      await getRelationshipProfile(relationId).then(async (e) => {
        adviceList.current = e;
        await pushInData({
          type: "initiateRelationship",
          subType: "directAdviceAddNew",
          text: "I need relationship advice for ",
          name: e?.nickname || e?.first_name || "this person",
          ...normalizeAdviceData(e),
        });
      });
    }
    fetchData();
  }, [adviceTitle, relationId, normalizeAdviceData]);

  // Handle invitation modal from URL
  useEffect(() => {
    if (!requestIdFromUrl) return;
    setInviteModalOpen(true);
    setInviteNotification({ requestId: requestIdFromUrl });
  }, [requestIdFromUrl]);

  // Initialize coaching sessions and minutes
  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const sessions = await getSessions();
        const hasInProgress = sessions?.payload?.some(
          (session) => session.status === "in_progress"
        );
        setLatestInProgressSession(hasInProgress);
      } catch (error) {
        console.error("Error fetching sessions:", error);
        setLatestInProgressSession(false);
      }
    };
    fetchSessions();
  }, []);

  // Fetch coaching minutes from functionality access API
  // If user has unlimited coaching, set to Infinity; otherwise use the available minutes
  useEffect(() => {
    if (!accessInitialized) return;
    
    // Check if user has unlimited coaching via functionality access
    if (hasUnlimitedCoaching()) {
      // Set to a large value to indicate unlimited
      setCoachingMinutes(Infinity);
      return;
    }
    
    // Get coaching minutes from functionality access
    const coachingInfo = getCoachingMinutes();
    if (coachingInfo.unlimited) {
      setCoachingMinutes(Infinity);
    } else {
      // Convert minutes to seconds for backward compatibility
      setCoachingMinutes(coachingInfo.available * 60);
    }
  }, [accessInitialized, hasUnlimitedCoaching, getCoachingMinutes]);

  // Set header content
  useLayoutEffect(() => {
    setHeaderContent(true);
  }, [setHeaderContent]);

  // Initialize loading state
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  // Initialize privacy state from localStorage on component mount
  useEffect(() => {
    const savedPrivacyMode = localStorage.getItem("chatPrivacyMode");
    if (savedPrivacyMode === "true") {
      setIsPrivacyActivated(true);
    }
  }, []);

  // Privacy activation sync
  useEffect(() => {
    isPrivacyActivatedRef.current = isPrivacyActivated;

    // Sync privacy state to localStorage immediately when it changes (permanent storage)
    if (isPrivacyActivated) {
      localStorage.setItem("chatPrivacyMode", "true");
    } else {
      localStorage.removeItem("chatPrivacyMode");
    }
  }, [isPrivacyActivated]);

  const buildElementsIntro = useCallback(async () => {
    try {
      const config = await fetchElementsIntroConfig();
      setElementsIntroConfig(config);
      return config;
    } catch (error) {
      console.error("Failed to fetch elements intro config:", error);
      return null;
    }
  }, []);

  const onAddNewContactWithChat = (data, history) => {
    if (data?.length === 0) {
      return;
    }
    const tmp = {
      name: data?.first_name + " " + data?.last_name,
      history: history,
      relationship_category: data?.relationship_category,
      relationship_goals: data?.relationship_goals,
      relationship_length: data?.relationship_length,
      relationship_status: data?.relationship_status,
      relationship_type: data?.relationship_type,
      user1_id: data?.user1_id,
      user2_id: data?.user2_id,
      nickname: data?.nickname,
      pressure: data?.pressure,
    };
    chatCreateRelationShip(tmp).then((res) => {
      if (res?.status === "success") {
        setchatData((prev) => [
          ...prev,
          {
            role: "assistant",
            content: res?.query || "something went wrong !!",
          },
        ]);
      }
    });
  };

  const pushInData = useCallback(async (data) => {
    // Navigate to chat when starting a conversation and pass the data
    try {
      if ((window.location && window.location.pathname) !== "/chat") {
        // Pass the user input via URL params so ChatInterface can pick it up
        const params = new URLSearchParams(window.location.search);

        if (typeof data === "string") {
          // Simple text input - pass as 'input' param
          params.set("input", encodeURIComponent(data));
        } else if (typeof data === "object" && data !== null) {
          // Complex object data - pass as JSON
          params.set("data", encodeURIComponent(JSON.stringify(data)));

          // For quick coaching topics, also set individual params for session continuity
          if (data.type === "quickCoachingTopic") {
            params.set("topic_id", data.topicId);
            params.set("option_id", data.optionId);
            params.set("quick", "true");
            // Pass topic title and category for header display
            if (data.topicTitle) {
              params.set("topic_title", encodeURIComponent(data.topicTitle));
            }
            if (data.categoryName) {
              params.set("category_name", encodeURIComponent(data.categoryName));
            }
          }
        }

        // Pass privacy state to ChatInterface via URL
        if (isPrivacyActivated) {
          params.set("privacy", "true");
        }
        // Note: localStorage is handled by the privacy sync effect

        // Preserve existing params (elements, scope, domain, level, etc.)
        const queryString = params.toString();
        navigate(`/chat${queryString ? `?${queryString}` : ""}`);
        return; // Exit early since we're navigating away
      }
    } catch (_) { }

    if (showEditRelationship) {
      setshowEditRelationship(false);
      isAddRelationProcess.current = false;
    }

    // If in Elements mode and user typed a custom prompt, persist it as topic
    if (isElementsMode && typeof data === "string") {
      elementsTopicRef.current = data;
    }

    setIsChatProgress(true);
    let txtToPass;

    if (chatSessionId.current === "" || chatSessionId.current === null) {
      await initiateChatSession(
        typeof data === "object" ? data?.text + data?.name : data
      ).then(async (chatIDRres) => {
        chatSessionId.current = chatIDRres?.payload?.chat_id;

        if (typeof data === "object" && data !== null && !Array.isArray(data)) {
          if (isAddRelationProcess.current) {
            onAddNewContactWithChat(data, chatDataHistoryRef.current);
          } else if ((data.type = "initiateRelationship")) {
            isRelationShipAdvice.current = true;

            if (data.subType === "directAdvice") {
              txtToPass = data?.text + data?.name;
              if (
                chatSessionId.current !== "" ||
                chatSessionId.current !== null
              ) {
                setchatData((prev) => [
                  ...prev,
                  { role: "user", content: data },
                ]);
                callArisReltionShipApi("");
                isRelationShipAdvice.current = true;
              }
            } else if (data.subType === "addNewContact") {
              isAddRelationProcess.current = true;
            } else if (data.subType === "directAdviceAddNew") {
              txtToPass = data?.text + data?.name;
              if (
                chatSessionId.current !== "" ||
                chatSessionId.current !== null
              ) {
                setchatData((prev) => [
                  ...prev,
                  { role: "user", content: data },
                ]);
                callArisReltionShipApi("");
                isRelationShipAdvice.current = true;
              }
            }
          }
        } else {
          txtToPass = data;
          if (chatSessionId.current !== "" || chatSessionId.current !== null) {
            setchatData((prev) => [...prev, { role: "user", content: data }]);
            callArisApi(data);
          }
        }
      });
    } else {
      if (typeof data === "object" && data !== null && !Array.isArray(data)) {
        if (isAddRelationProcess.current) {
          onAddNewContactWithChat(data, chatDataHistoryRef.current);
        } else if ((data.type = "initiateRelationship")) {
          isRelationShipAdvice.current = true;
          if (data.subType === "directAdvice") {
            txtToPass = data?.text + data?.name;
            if (chatSessionId.current !== "" || chatSessionId.current !== null) {
              setchatData((prev) => [
                ...prev,
                { role: "user", content: data },
              ]);
              callArisReltionShipApi("");
              isRelationShipAdvice.current = true;
            }
          } else if (data.subType === "addNewContact") {
            isAddRelationProcess.current = true;
          } else if (data.subType === "directAdviceAddNew") {
            txtToPass = data?.text + data?.name;
            if (chatSessionId.current !== "" || chatSessionId.current !== null) {
              setchatData((prev) => [
                ...prev,
                { role: "user", content: data },
              ]);
              callArisReltionShipApi("");
              isRelationShipAdvice.current = true;
            }
          }
        }
      } else {
        txtToPass = data;
        if (chatSessionId.current !== "" || chatSessionId.current !== null) {
          setchatData((prev) => [...prev, { role: "user", content: data }]);
          callArisApi(data);
        }
      }
    }
  }, [navigate, showEditRelationship, isElementsMode]);

  const callArisApi = async (data) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);
      const response = await chatArisApi(
        chatSessionId.current,
        data,
        isElementsMode,
        elementsContextRef.current,
        elementsTopicRef.current
      );

      if (response?.body) {
        const reader = response.body.getReader();
        let accumulatedContent = "";

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = new TextDecoder().decode(value);
          const lines = chunk.split('\n');

          for (const line of lines) {
            if (line.trim() && line.startsWith('data: ')) {
              try {
                const jsonStr = line.slice(6);
                if (jsonStr === '[DONE]') continue;

                const parsed = JSON.parse(jsonStr);
                if (parsed.content) {
                  accumulatedContent += parsed.content;
                  setchatData((prev) => {
                    const newData = [...prev];
                    if (newData.length > 0) {
                      newData[newData.length - 1] = {
                        ...newData[newData.length - 1],
                        content: accumulatedContent
                      };
                    }
                    return newData;
                  });
                }
              } catch (e) {
                console.error('Error parsing streaming response:', e);
              }
            }
          }
        }
      }
    } catch (error) {
      console.error("Error in callArisApi:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again."
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  const callArisReltionShipApi = async (data) => {
    try {
      setchatData((prev) => [...prev, { role: "assistant", content: "" }]);
      const response = await chatArisApiRelationShip(
        chatSessionId.current,
        data,
        adviceList.current,
        relationshipFollowupRef.current
      );

      if (response?.body) {
        const reader = response.body.getReader();
        let accumulatedContent = "";

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const chunk = new TextDecoder().decode(value);
          const lines = chunk.split('\n');

          for (const line of lines) {
            if (line.trim() && line.startsWith('data: ')) {
              try {
                const jsonStr = line.slice(6);
                if (jsonStr === '[DONE]') continue;

                const parsed = JSON.parse(jsonStr);
                if (parsed.content) {
                  accumulatedContent += parsed.content;
                  setchatData((prev) => {
                    const newData = [...prev];
                    if (newData.length > 0) {
                      newData[newData.length - 1] = {
                        ...newData[newData.length - 1],
                        content: accumulatedContent
                      };
                    }
                    return newData;
                  });
                }
              } catch (e) {
                console.error('Error parsing streaming response:', e);
              }
            }
          }
        }
      }

      relationshipFollowupRef.current = true;
    } catch (error) {
      console.error("Error in callArisReltionShipApi:", error);
      setchatData((prev) => {
        const newData = [...prev];
        if (newData.length > 0) {
          newData[newData.length - 1] = {
            ...newData[newData.length - 1],
            content: "I apologize, but I encountered an error. Please try again."
          };
        }
        return newData;
      });
    } finally {
      setIsChatProgress(false);
    }
  };

  const onOptionSelected = (e) => {
    const text = e?.text?.trim();
    if (text === "Other (Write your own below)") {
      return;
    }
    if (text?.includes("Elements")) {
      setIsElementsMode(true);
      setHasSelectedDomain(true);
      if (e?.context) {
        elementsContextRef.current = {
          scope: e.context.scope || null,
          domain: e.context.domain || null,
          level: e.context.level || null,
        };
      }
      return;
    }
    elementsTopicRef.current = text;
    pushInData(text);
    return;
  };

  const loadLatestChatHistory = () => {
    // Implementation for loading chat history
  };

  const onAddRealtionClose = (val) => {
    setshowEditRelationship(val);
  };

  const onAddedRelationShip = (data) => {
    pushInData(data);
    setshowEditRelationship(false);
  };

  const handleRouteToSubscription = () => {
    navigate("/pricing");
  };

  // Modal handlers for coaching minutes
  const handleOpenMinutesModal = () => {
    setShowMinutesModal(true);
  };

  const handleCloseMinutesModal = () => {
    setShowMinutesModal(false);
    // Refresh page after purchase to update minutes
    window.location.reload();
  };

  // Coaching Topics handlers
  const handleOpenCoachingTopics = () => {
    setTopicsSlideFromLeft(false);
    setShowCoachingTopicsModal(true);
  };

  const handleOpenYourElements = () => {
    setShowCoachingTopicsModal(false);
    setShowYourElementsModal(true);
  };

  const handleCloseYourElements = () => {
    setShowYourElementsModal(false);
  };

  const handleTopicNavigationAction = (_topic, target) => {
    if (target?.kind === "internal_route" && target.value === "/elements") {
      handleOpenYourElements();
      return;
    }
    if (target?.kind === "external_url" && target.value) {
      window.open(target.value, "_blank", "noopener,noreferrer");
      return;
    }
    console.warn("[DashboardChat] unsupported topic navigation target", target);
  };

  const handleCloseCoachingTopics = () => {
    setShowCoachingTopicsModal(false);
    setTopicsSlideFromLeft(false);
  };

  const handleSelectTopic = (topic) => {
    setSelectedTopic(topic);
    setShowCoachingTopicsModal(false);
    setShowTopicOptionsModal(true);
  };

  const handleCloseTopicOptions = () => {
    setShowTopicOptionsModal(false);
    setSelectedTopic(null);
  };

  const handleBackToTopics = () => {
    setShowTopicOptionsModal(false);
    setSelectedTopic(null);
    setTopicsSlideFromLeft(true);
    setShowCoachingTopicsModal(true);
  };

  const handleStartTopicSession = (sessionDescriptor) => {
    setShowTopicOptionsModal(false);

    // Use conversation_starter as the initial message if available
    const initialMessage = sessionDescriptor.conversationStarter
      || (sessionDescriptor.optionTitle
        ? `${sessionDescriptor.topicTitle} - ${sessionDescriptor.optionTitle}`
        : sessionDescriptor.topicTitle);

    // Build the topic data object to pass to ChatInterface
    const topicData = {
      type: "quickCoachingTopic",
      topicId: sessionDescriptor.topicId,
      topicTitle: sessionDescriptor.topicTitle,
      categoryId: sessionDescriptor.categoryId,
      categoryName: sessionDescriptor.categoryName,
      optionId: sessionDescriptor.optionId,
      optionTitle: sessionDescriptor.optionTitle,
      durationSeconds: sessionDescriptor.durationSeconds,
      conversationStarter: sessionDescriptor.conversationStarter,
      prompt: sessionDescriptor.prompt,
      quick: true,
      text: initialMessage,
    };

    pushInData(topicData);
  };

  return (
    <>
      <SessionSelection
        showLiveSessionModal={showLiveSessionModal}
        setshowLiveSessionModal={setshowLiveSessionModal}
      />
      <InviteDecisionModal
        isOpen={inviteModalOpen}
        onClose={() => {
          setInviteModalOpen(false);
          setInviteNotification(null);
          // Clean up URL params
          const params = new URLSearchParams(searchParams);
          params.delete("request");
          const qs = params.toString();
          navigate(qs ? `/dashboard?${qs}` : "/dashboard", { replace: true });
        }}
        notification={inviteNotification}
        onAccept={() => {
          setInviteModalOpen(false);
          setInviteNotification(null);
          // Clean up URL params and navigate to chat
          const params = new URLSearchParams(searchParams);
          params.delete("request");
          const qs = params.toString();
          navigate(qs ? `/chat?${qs}` : "/chat", { replace: true });
        }}
      />
      {showEditRelationship && (
        <AddRelationShipChatModal
          title={"Add new Relationship"}
          onClose={onAddRealtionClose}
          contact={collectedFormDataRelationship}
          onAddedRelationShip={onAddedRelationShip}
        />
      )}
      {loading ? (
        <DefaultLoader />
      ) : (
        <>
          <div
            className={
              "relationship-hero-container" +
              (chatData.length !== 0 ? " align-down" : "")
            }
          >
            <div
              key={`init-${coachingMinutes === null ? 'pending' : (coachingMinutes <= 0 ? 'no-min' : 'has-min')}`}
              className={`relationship-parent-scroll-container ${(loading || isLoading) && "loading"
                } ${!(loading || isLoading) &&
                chatData.length === 0 &&
                "initial-chat"
                }`}
            >
              <div
                className={`relationship-container ${chatData.length === 0 && "relation-chat-cont-initial"
                  }`}
              >
                <InitialChat
                  onEnterData={pushInData}
                  latestInProgressSession={latestInProgressSession}
                  enableCoaching={enableCoaching}
                  setShowLiveSessionModal={setshowLiveSessionModal}
                  isChatProgress={isChatProgress}
                  loadLatestChatHistory={loadLatestChatHistory}
                  loading={loading}
                  setLoading={setLoading}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  isPrivacyActivated={isPrivacyActivated}
                  setIsPrivacyActivated={setIsPrivacyActivated}
                  contactSelectionRelationAdvice={contactSelectionRelationAdvice}
                  coachingMinutes={coachingMinutes}
                  onOpenMinutesModal={handleOpenMinutesModal}
                  onOpenCoachingTopics={handleOpenCoachingTopics}
                  onOpenYourElements={handleOpenYourElements}
                />
              </div>
              {/* Aris Tour: Keyboard Home */}
              {isKeyboardHome && (
                <ArisTour
                  id="keyboard"
                  steps={[
                    { selector: '.rl-input', content: 'Start a new chat by typing in this box', placement: 'top' },
                    { selector: '.inline-mic-icon', content: 'Use speech-to-text to eliminate the need for typing.', placement: 'top' },
                    {
                      selector: '.your-elements-btn',
                      content: (
                        <div>
                          <p>Explore <strong>Your Elements</strong> — your personal Periodic Table of the Self.</p>
                        </div>
                      ),
                      placement: 'top',
                    },
                    {
                      selector: '.quick-session-topics-btn',
                      content: (
                        <div>
                          <p>Access suggested <strong>dialogues sessions.</strong></p>
                        </div>
                      ),
                      placement: 'top',
                    },
                    { selector: '.chat-lock-hero-cntr', content: 'Use private mode for encrypted chats that are never stored.', placement: 'top' },
                    { selector: '.voice-switch-btn', content: 'Switch to voice session at any time.', placement: 'bottom' },
                  ]}
                  routeMatch={(p) => p === '/dashboard'}
                  readySelectors={['.rl-input', '.relationship-input-cntr', '.textarea-input']}
                  spotlightRadiusMap={{
                    '.rl-input': 12,
                    '.inline-mic-icon': 44,
                    '.chat-lock-hero-cntr': 44,
                    '.voice-switch-btn': 44,
                  }}
                  defaultSpotlightRadius={10}
                />
              )}
            </div>
          </div>
          <Tooltip
            id="tooltip-anchor"
            place={screenWidth <= 488 ? "top-end" : "top"}
            border={"2px solid #D9D9D9"}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "8px",
              color: "#000000",
              zIndex: 999999,
            }}
            clickable
          >
            <p
              style={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: "14px",
                marginBottom: "0.25rem",
                cursor: "default",
                marginTop: 0,
              }}
            >
              Your ARIS Dialogues minutes <br />
              have expired. Please add <br />
              more to continue
            </p>
            <p
              style={{
                textAlign: "center",
                fontWeight: 400,
                fontSize: "12px",
                lineHeight: "14.4px",
                color: "#4674FE",
                cursor: "pointer",
                margin: 0,
              }}
              onClick={handleRouteToSubscription}
            >
              Buy Minutes
            </p>
          </Tooltip>
        </>
      )}

      {/* Coaching Minutes Modal */}
      {!isMobile ? (
        <ChatModal
          isOpen={showMinutesModal}
          onClose={handleCloseMinutesModal}
          width="462px"
          height="auto"
        >
          <RequestCoachingMinutes
            isOpen={showMinutesModal}
            onClose={handleCloseMinutesModal}
            remainingMinutes={Math.floor((coachingMinutes || 0) / 60)}
            redirectUrl="/dashboard"
          />
        </ChatModal>
      ) : (
        <MobilePopUp
          isOpen={showMinutesModal}
          onClose={handleCloseMinutesModal}
          hideClose={false}
        >
          <RequestCoachingMinutes
            isOpen={showMinutesModal}
            onClose={handleCloseMinutesModal}
            remainingMinutes={Math.floor((coachingMinutes || 0) / 60)}
            redirectUrl="/dashboard"
          />
        </MobilePopUp>
      )}

      {/* Coaching Topics Modal */}
      <CoachingTopicsModal
        isOpen={showCoachingTopicsModal}
        onClose={handleCloseCoachingTopics}
        onSelectTopic={handleSelectTopic}
        onNavigationAction={handleTopicNavigationAction}
        platform="web"
        sessionType="keyboard"
        slideFromLeft={topicsSlideFromLeft}
      />

      {/* Topic Options Modal */}
      <TopicOptionsModal
        isOpen={showTopicOptionsModal}
        onClose={handleCloseTopicOptions}
        topic={selectedTopic}
        platform="web"
        sessionType="keyboard"
        onStartSession={handleStartTopicSession}
        onBack={handleBackToTopics}
      />

      {/* Your Elements Modal */}
      <YourElementsModal
        isOpen={showYourElementsModal}
        onClose={handleCloseYourElements}
      />
    </>
  );
}

export default DashboardChat;
